import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";

import UserDetailsForm from "../../components/account/UserDetailsForm.jsx";
import withBasicForm from "../../components/forms/withBasicForm.js";

const UserDetailsBasicForm = withBasicForm(UserDetailsForm);

class UserDetailsTab extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    violationErrors: PropTypes.object
  };

  // -- RENDER -- //

  render() {
    return <UserDetailsBasicForm {...this.props} />;
  }
}

export default UserDetailsTab;
